import { useMemo } from "react";
import { routes } from "../../../app/routes";
import { useUrlParams } from "../../../hooks";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";

export const ServiceTypeTopbar = (props: any) => {

  const id = useUrlParams("id");

  const submenuItems: TopbarMenuItem[] = useMemo((): TopbarMenuItem[] => {
    const items: TopbarMenuItem[] = [
      {
        label: "Back",
        icon: IconDefinitions.back,
        url: routes.serviceType.index,
      },
      {
        label: "Details",
        icon: IconDefinitions.squareInfo,
        url: routes.serviceType.details,
        activeMatch: routes.serviceType.details,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      {
        label: "Services",
        icon: IconDefinitions.gear,
        url: routes.serviceType.service,
        activeMatch: routes.serviceType.service,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
    ];

    return items;
  }, [id]);


  return <TopbarSubmenu className="p-0" items={submenuItems} />;
};

export default ServiceTypeTopbar;

